import * as React from 'react';
import { experimentUtils } from 'core/experiments';
import A from '../../assets/images/NCSA/TeamSnap-Multi-Sport-Banner-Display.png';
import B from '../../assets/images/NCSA/TeamSnap-Email-CTA-Banner.png';
import C from '../../assets/images/NCSA/TeamSnap-Banner-Display.png';
import D from '../../assets/images/NCSA/NCSA-Ad_1-3.png';
import E from '../../assets/images/NCSA/300x250.jpg';
import { useAmplitude } from 'state/hooks/useAmplitude';
import { TextLink } from '@teamsnap/teamsnap-ui';
import { ampli } from 'core/ampli';

export const NCSA_EXPERIMENT_NAME = 'ncsa-reg2';
const VARIANT_NAME = 'treatment';

export const NCSA = () => {
  const { amplitudeTrack } = useAmplitude();

  const isExperimentEnabled =
    experimentUtils.isExperimentEnabled(NCSA_EXPERIMENT_NAME, VARIANT_NAME) ||
    experimentUtils.isExperimentEnabledForTesting(NCSA_EXPERIMENT_NAME, VARIANT_NAME);

  React.useEffect(() => {
    if (isExperimentEnabled) {
      amplitudeTrack.ncsaReg2Viewed();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExperimentEnabled]);

const onClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
    e.preventDefault();
    amplitudeTrack.ncsaReg2Clicked();
    ampli.flush();
    window.open('https://www.ncsasports.org/join/get-recruited?eid=32233');
};

  if (!isExperimentEnabled) {
    return null;
  }

  return (
    <>
      <TextLink className="sui-border-none sui-w-full" onClick={onClick} data-testid="ncsa-button">
        <img id="NSCA-img-A" src={A} alt="NCSA" className="sui-mb-1 sui-w-full" />
        <img id="NSCA-img-B" src={B} alt="NCSA" className="sui-mb-1 sui-w-full" style={{ display: 'none'}} />
        <img id="NSCA-img-C" src={C} alt="NCSA" className="sui-mb-1 sui-w-full" style={{ display: 'none'}} />
        <img id="NSCA-img-D" src={D} alt="NCSA" className="sui-mb-1 sui-w-full" style={{ display: 'none'}} />
        <img id="NSCA-img-E" src={E} alt="NCSA" className="sui-mb-1 sui-w-full" style={{ display: 'none'}} />
      </TextLink>
    </>
  );
};

const NCSAWrapper = () => (
    <div id={NCSA_EXPERIMENT_NAME} >
        <NCSA />
    </div>
)


export default NCSAWrapper;
